import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';

export default function OrderSummary({
  address,
  order,
  product,
  productPrice,
  quantity,
  sCheckoutURL,
  subjects,
  contact,
}) {
  const renderAddressTwo = () => {
    return address.address2 ? ` ${address.address2},` : '';
  };
  const renderDeliveryInstructions = () => {
    if (!address.deliveryInstructions) return;

    return (
      <Grid item xs={12}>
        <Typography variant="h6">Delivery instructions</Typography>
        <Typography variant="body1">{address.deliveryInstructions}</Typography>
      </Grid>
    );
  };

  const formattedSubjectsBirthDate = () => {
    return dayjs(subjects[0].dob).format('MMM D, YYYY');
  };
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h5">Order {order} Summary</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1">
          {product.title} x {quantity}
        </Typography>
        <Typography variant="body1">${parseFloat(productPrice.replace('$', '')) * quantity}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6">{subjects[0].name}</Typography>
        <Typography variant="body1">{contact}</Typography>
        <Typography variant="body1">{formattedSubjectsBirthDate()}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6">Shipping Address</Typography>
        <Typography variant="body1">
          {subjects[0].name}, {address.address1},{renderAddressTwo} {address.city}, {address.state}, {address.zipcode}
        </Typography>
      </Grid>
      {renderDeliveryInstructions()}
    </>
  );
}
